import { render, staticRenderFns } from "./MaydayWebNotificationModalItemCheckbox.vue?vue&type=template&id=2e966b2c&"
import script from "./MaydayWebNotificationModalItemCheckbox.vue?vue&type=script&lang=js&"
export * from "./MaydayWebNotificationModalItemCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports